module.exports = __webpack_public_path__ + "static/img/logo_sjhfdgy.9316ca2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/logo_sjhfdgy.png
// module id = EohV
// module chunks = 15